<template>
    <div class="popup" v-cloak v-if="isShow" style="zIndex:200">
        <div class="content" id="licenseCode" :class="isSuccess?'license-success':''">
            <div class="title">
                <span v-if="!isSuccess">{{$t('language.license.codeTitle')}}</span>
                <span v-else>{{$t('language.license.codeSucTitle')}}</span>
                <div class="icon white-close dialog-close" @click="isShow=false;"></div>
            </div>
            <div class="personInfo-content" v-if="!isSuccess">
                <img src="../../../assets/images/workspace/license_key.png">
                <strong>{{$t('language.license.codeTipTitle')}}</strong>
                <span style="font-size: 14px;cursor: context-menu;color: #333333;" v-if="user.vip">{{$t('language.license.codeTipTextVip')}}</span>
                <span style="font-size: 14px;cursor: context-menu;color: #333333;" v-else>{{$t('language.license.codeTipText')}}</span>
                <div class="license-function">
                    <el-input v-model="code" class="license-input" :class="isCodeError?'error':''" @input="changeLicenseCode"></el-input>
                    <el-button v-loading="isLoading" @click="checkLicenseCode"><span v-if="!isLoading">{{$t('language.common.ok')}}</span></el-button>
                    <span v-if="isCodeError" class="license-input-error" >{{errorText}}</span>
                </div>
                <div class="license-footer">
                    {{$t('language.license.codeFooter')}}<br>
                    <a href="mailto:support@multcloud.com">support@multcloud.com</a>
                </div>
            </div>
            <div class="personInfo-content" v-else>
                <img src="../../../assets/images/workspace/license_success.png">
                <strong style="flex:1;margin-top:10px;">{{$t('language.license.codeSucTip')}}</strong>
                <el-button @click="isShow=false;" class="license-success-btn">{{$t('language.common.ok')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import common_util from '../../../js/workspace/common_util';
export default {
    name: 'licenseCodePopup',
    data: function () {
        return {
            isShow: false,
            user: common_util.getUser(),
            code: '',
            isCodeError: false,
            errorText: '',
            isLoading: false,
            isSuccess: false,
            flag: false,//标志，暂时用于是否关闭后进入活动弹窗
            isSharewareCode: false,//是否为BAAYK667N5K3K0N6/BAAYK8Q4M7N2R6P9兑换码
        }
    },
    watch: {
        isShow(newVal,oldVal) {
            // 关闭的时候初始化
            if(!newVal) {
                this.code = '';
                this.isCodeError = false;
                this.errorText = '';
                this.isLoading = false;
                this.isSuccess = false;
                // if(this.flag&&this.$route.name != 'paySys') {
                //     this.$router.push('/mc_project/paySys');
                // }
                if(this.flag&&!this.isSharewareCode) {
                    this.$parent.salePopupShow(true);
                }
                this.flag = false;
            }
        }
    },
    methods: {
        // 处理显示效果
        changeLicenseCode(value) {
            let temp = value.replace(/[^a-zA-Z0-9]/g, '').substring(0, 16).toUpperCase();// 仅保留16位以下的数字和字母，并且每4个字符加一个横杠
            if(!temp.substring(0,4)==="MCGO") {
                this.code = temp.replace(/(.{4})(?!$)/g, '$1 - ');// 每4个字符加一个横杠
            }else {
                this.code = temp;
            }
            if(this.isCodeError) {
                // 关闭报错
                this.isCodeError = false;
            }
        },
        // 执行兑换操作
        checkLicenseCode() {
            if(this.isCodeError) {
                // 关闭报错
                this.isCodeError = false;
            }
            let licenseCode = this.code.replace(/[^a-zA-Z0-9]/g, '');
            if(!licenseCode||licenseCode.length<1) {
                // 报错
                this.isCodeError = true;
                this.errorText = this.$t('language.exception.noLicenseCode');
                return;
            }
            // 开始兑换
            this.isLoading = true;
            this.Utils.doSubscriptionPostRequest('license_redemption',{ud:this.user.id,code:licenseCode}).then(res=>{
                this.isLoading = false;
                // 兑换成功更新用户信息
                if (res.status == 200) {
                  // 判断是否为BAAYK667N5K3K0N6或BAAYK8Q4M7N2R6P9兑换码
                    if (licenseCode === 'BAAYK667N5K3K0N6' || licenseCode === 'BAAYK8Q4M7N2R6P9') {
                      this.isSharewareCode = true;
                    }else {
                      if(licenseCode === 'SHAREWARE06ONSAL') {
                        this.flag = true;
                      }
                      this.isSuccess = true;
                    }
                    this.updateUser(0);
                    if(!this.isSharewareCode && this.$route.name == 'paySys') {
                        location.reload();
                    }
                    // else {
                    //     this.$router.push('/mc_project/paySys');
                    // }
                } else if(res.status == 400 && res.reason == 'purchaseLimited') {
                    // 报错
                    this.isCodeError = true;
                    let schemeName = '';
                    if(res.msg == 'old set meal') {
                        schemeName = this.getOldSchemeName();
                    }else {
                        schemeName = this.$t('language.paySystem.arguments.title.'+res.msg);
                    }
                    this.errorText = this.$t('language.exception.licenseUpgradError',{scheme:schemeName});
                } else {
                    // 报错
                    this.isCodeError = true;
                    this.errorText = this.$t('language.exception.licenseCodeError');
                }
            });
        },
        getOldSchemeName() {
            //如果是老套餐则用
            this.user = commonUtils.getUser();
            let nowSchemeName;
            if (this.user.vip) { //如果不是免费用户
                if (this.user.payLevel > 1) { //大于1为有限，如果为有限月，有限季，有限年用户
                    //计算若选择年无限应该付的金额
                    if (this.user.payType == 'Monthly') {
                        nowSchemeName = 'language.paySystem.limitedMonth';
                    } else if (this.user.payType == 'Quarterly') {
                        nowSchemeName = 'language.paySystem.twoMonthree';
                    } else {
                        //有限年套餐去掉无限年
                        nowSchemeName = 'language.paySystem.fourMOne';
                    }
                } else { //如果为无限
                    if (this.user.payType == 'Monthly') { //如果为无限月
                        nowSchemeName = 'language.paySystem.monthlyUnlimited';
                    }
                    if (this.user.payType == 'Yearly') { //如果为无限年
                        nowSchemeName = 'language.paySystem.YearlyUnlimited';
                    }
                }
            }
            return nowSchemeName;
        },
        // 更新用户信息
        updateUser(errorNum) {
            this.Utils.doUserHaveLoginRequest('get', {
                ud: this.user.id,
                salt: this.user.salt
            }).then(response => {
                if (response.status == 200) {
                    common_util.setUserToLocal(response.user);
                    common_util.setUserCookies(response.user);
                    this.$store.commit("setUpdateUserSchems", true);
                    // BAAYK667N5K3K0N6/BAAYK8Q4M7N2R6P9兑换码：更新用户信息后打开促销活动弹窗
                    if (this.isSharewareCode) {
                        this.isSharewareCode = false;
                        this.flag = false; // 防止watch中触发salePopupShow
                        this.isShow = false;
                        const payTimeMs = new Date(response.user.payTime).getTime();
                        const expireTime = payTimeMs + 15 * 60 * 1000;
                        const countdownSeconds = Math.max(0, Math.floor((expireTime - Date.now()) / 1000));
                        if (countdownSeconds > 0 && this.$parent.$refs.giveawayActiveSucDialog) {
                            this.$parent.$refs.giveawayActiveSucDialog.showPopup({
                                countdownSeconds: countdownSeconds
                            });
                        }
                    }
                    //刷新流量
                    this.$parent.createPage();
                } else {
                    if(!errorNum) {
                        errorNum = 0;
                    }
                    if(errorNum<6) {
                        let t = setTimeout(() => {
                            this.updateUser(errorNum+1);
                        }, 1000);
                    }else {
                        // 报错
                        this.isCodeError = true;
                        this.errorText = '';
                    }
                }
            });
        }
    }
}
</script>

<style scoped>
#licenseCode {
    width: 600px;/*no*/
    height: 440px;/*no*/
}

#licenseCode.license-success {
    width: 480px;/*no*/
    height: 330px;/*no*/
}

.personInfo-content {
    padding: 20px;/*no*/
    height: calc(100% - 40px);/*no*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    font-family: Arial;
    letter-spacing: 0em;
}

.personInfo-content strong {
    font-size: 20px;/*no*/
    color: #333333;
    line-height: 23px;/*no*/
    margin: 30px auto 10px;/*no*/
    cursor: context-menu;
}

.personInfo-content img {
    user-select: none;
}

.license-function {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: calc(100% - 90px);/*no*/
    flex: 1;
    gap: 10px;/*no*/
    margin-top: 10px;/*no*/
}

.license-function .el-input {
    flex: 1;
    height: 40px;/*no*/
}

.license-function .el-button {
    margin-top: 10px;/*no*/
    height: 40px;/*no*/
    min-width: 100px;/*no*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 30px;/*no*/
    gap: 6px 10px;/*no*/
    flex-wrap: wrap;
    align-content: center;
    border-radius: 4px;/*no*/
    background: #5562B4;
    color: #FFFFFF;
    font-size: 16px;
}

.license-input >>> .el-input__inner{
    text-align: center;
    font-family: Microsoft YaHei UI;
    font-size: 18px;/*no*/
    font-weight: bold;
    line-height: 22px;/*no*/
    letter-spacing: 0em;
    color: #333333;
}

.license-input.error >>> .el-input__inner{
    border: 1px solid #FD5236;
}

.license-footer {
    font-size: 14px;/*no*/
    line-height: 16px;/*no*/
    color: #6F6F6F;
    cursor: context-menu;
}

.license-footer a {
    color: #5562B4;
    cursor: pointer;
}

.license-input-error {
    font-size: 12px;
    color: #FD5236;
    position: absolute;
    top: 60px;/*no*/
    left: 0;
}

#licenseCode >>> .el-loading-spinner .path {
    stroke: #ffffff !important
}

#licenseCode >>> .el-loading-spinner .circular {
    height: 20px !important;
    width: 20px !important;
}

#licenseCode >>> .el-loading-spinner {
    padding-top: 10px !important;
    /*no*/
}

#licenseCode >>> .el-loading-mask {
    background: transparent;
}

.personInfo-content .license-success-btn {
    margin-top: 10px;/*no*/
    height: 30px;/*no*/
    min-width: 128px;/*no*/
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px 30px;/*no*/
    gap: 6px 10px;/*no*/
    flex-wrap: wrap;
    align-content: center;
    border-radius: 4px;/*no*/
    background: #5562B4;
    color: #FFFFFF;
    font-size: 14px;/*no*/
    font-family: Arial;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/license_code_popup.vue